import { Component, Input } from '@angular/core';
import { DnButtonBaseComponent } from '../../base/dn-button-base/dn-button-base.component';
import { MarketingBtnSize } from './marketing-btn.config';
import { DnBtnSize } from '../../dn-primary-btn/dn-primary-btn.config';

@Component({
  selector: 'dn-marketing-btn',
  templateUrl: './dn-marketing-btn.component.html',
  styleUrl: './dn-marketing-btn.component.scss',
  standalone: false,
})
export class DnMarketingBtnComponent extends DnButtonBaseComponent {
  @Input() marketBtnSize: MarketingBtnSize = DnBtnSize.SMALL;
}
